export type UserSameDeviceWorkspaceContext = {
  deviceInstallId?: string;
  release?: string;
  appVersion?: string;
  platform?: string;
};

export function appendUserSameDeviceWorkspaceContext(
  params: URLSearchParams,
  context: UserSameDeviceWorkspaceContext,
): URLSearchParams {
  const nextParams = new URLSearchParams(params);

  if (context.deviceInstallId) {
    nextParams.set("deviceInstallId", context.deviceInstallId);
  }

  if (context.release) {
    nextParams.set("release", context.release);
  }

  if (context.appVersion) {
    nextParams.set("appVersion", context.appVersion);
  }

  if (context.platform) {
    nextParams.set("platform", context.platform);
  }

  return nextParams;
}

export function readUserSameDeviceWorkspaceContext(
  params: URLSearchParams,
): UserSameDeviceWorkspaceContext | undefined {
  const deviceInstallId = params.get("deviceInstallId")?.trim();
  const release = params.get("release")?.trim();
  const appVersion = params.get("appVersion")?.trim();
  const platform = params.get("platform")?.trim();

  if (!deviceInstallId && !release && !appVersion && !platform) {
    return undefined;
  }

  return {
    deviceInstallId: deviceInstallId || undefined,
    release: release || undefined,
    appVersion: appVersion || undefined,
    platform: platform || undefined,
  };
}
